'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Tab
 *
 * @class
 */

class FormTextInput extends Core {

    _defaults() {
        return {
            target: '.js-formtextinput',
            fields: {
                'placeholder': "",
                'value': "",
                'isReadOnly': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <input class='editor__form__textinput js-editor__form__textinput' placeholder="<%- placeholder %>" value="<%- value %>"></input>
        `;

        super.render();

        if(options.fields['isReadOnly']) {
            this.$el.attr('disabled', true);
            this.$el.addClass('editor__form__textinput--disabled');
        }

        /**
         * Text input
         *
         * @fires FormTextInput#_valuechanged
         */

        this.$el.on('input', this._valuechanged);
        
        var self = this;
        this.$el.keypress(function(e) {
            if (e.which == 13) {
                self._enter(e);
            }
        });
    }

    /**
     * @event FormTextInput#Cioui:Form:value
     * @property {String}Cioui:Form:value
     * @returns {String} value - the new text input obj
     */

    _valuechanged(e){
        $(e.currentTarget).trigger('Cioui:Form:value', $(e.currentTarget).val());
    }

    _enter(e){
        $(e.currentTarget).trigger('Cioui:Form:enter', $(e.currentTarget).val());
    }

    /**
     * setValue
     *
     * @param {string} value - the value that you want to set
     */

    setValue(value){
        this.$el.val(value);
    }
}
module.exports = FormTextInput;